<template>
    <div class="main-body">
        <div class="header">退住管理</div>
        <div class="out">

            <div class="search2">

                <div style="float:right">

                  <el-input placeholder="输入姓名" v-model="elderlyName" clearable style="width: 150px;margin-right: 10px;"></el-input>
                  <el-button size="mini" type="primary" @click="getList">搜索</el-button>

                </div>

                <div style="clear: both;"></div>
            </div>


            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>

                <el-table-column prop="elderlyName" label="老人"></el-table-column>

                <el-table-column prop="elderlyDTO.phone" label="手机号"></el-table-column>

                <el-table-column prop="remarks" label="结算备注"></el-table-column>
                <el-table-column prop="total" label="结算金额"></el-table-column>
                <el-table-column prop="elderlyFund.balance" label="余额"></el-table-column>
              <el-table-column prop="elderlyFund.balance" label="余额"></el-table-column>
              <el-table-column prop="elderlyFund.imprest" label="备用金"></el-table-column>
              <el-table-column prop="elderlyFund.advance" label="预交金"></el-table-column>
                <el-table-column prop="createTime" :formatter="formatterTime" label="退住时间"></el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                elderlyName:'',
                currentPage:1,
                th:0,
            }
        },

        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"RetreatSettle/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

        }
    }
</script>

